/*
  Maps a shared-server hostname to its Sentry environment. Hostnames carry the
  environment's digit (flocknoteqa1.internal, flocknotedev1.internal, ...), so
  each check must include that digit - matching "flocknoteqa.internal" against
  "flocknoteqa1.internal" fails and the host falls through to "production".

*/
export const environmentForHostname = (hostname) => {
  if (hostname.includes("flocknote.com")) {
    return "production";
  } else if (hostname.includes("flocknotestaging.internal")) {
    return "staging";
  } else if (hostname.includes("flocknote-isolated-prod2.internal")) {
    return "isolated-prod2";
  } else if (hostname.includes("flocknote-isolated-prod.internal")) {
    return "isolated-prod";
  } else if (hostname.includes("flocknoteqa1.internal")) {
    return "qa";
  } else if (hostname.includes("flocknotedev1.internal")) {
    return "dev1";
  } else if (hostname.includes("flocknotedev2.internal")) {
    return "dev2";
  } else if (hostname.includes("flocknotedev3.internal")) {
    return "dev3";
  } else if (hostname.includes("flocknotedev4.internal")) {
    return "dev4";
  } else if (hostname.includes("flocknotedev5.internal")) {
    return "dev5";
  } else if (hostname.includes("flocknotedev6.internal")) {
    return "dev6";
  } else if (hostname.includes("flocknotedev7.internal")) {
    return "dev7";
  } else {
    return "production";
  }
};

export const getSentryEnvironment = () => {
  const hostname =
    (window && window.location && window.location.hostname) || "";

  /*
    NODE_ENV === "production" on all of our dev servers (since we do the React build on the server),
    so for dev servers we need to check the hostname to determine the environment.
  */
  if (process.env.NODE_ENV !== "production") {
    // handles "development" and "test"
    return process.env.NODE_ENV;
  }

  return environmentForHostname(hostname);
};
